/*
import { useEffect } from 'react';
import CreativeProvider from '../providers/creative/index.js';

const provider = new CreativeProvider();
*/

export { useCreativeProvider };

function useCreativeProvider() {
  console.warn('DEPRECATED: using useCreativeProvider is not allowed anymore.');
}
/*
function useCreativeProvider(url, cb) {
  useEffect(() => {
    if (url === null) {
      return cb(null, null);
    }
    provider.getByUrl(url).subscribe({
      next(n) {
        cb(n, null);
      },
      error(err) {
        /// TODO: fix problem on error, hook does not work any more after error, may be problem in consumer, see debug-layer
        cb(null, err);
      },
    });
    /!*
      .then((schema) => {
        if (schema.origin === url) {
          cb(null, schema);
        }
      })
      .catch(cb);
*!/
  }, [cb, url]);
}
*/
